import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { CoreModule } from '@core';
import { SharedModule } from '@shared';
import { HomeModule } from './home/home.module';
import { InspirationModule } from './inspiration/inspiration.module';
import { ShellModule } from './shell/shell.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { IconModule } from '@shared/icon.module';

import { MAT_DATE_LOCALE } from '@angular/material/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import {
  NgxPiwikProModule,
  NgxPiwikProRouterModule,
} from '@piwikpro/ngx-piwik-pro';
import { Config } from './@core/config';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule.forRoot(),
    BrowserAnimationsModule,
    MaterialModule,
    CoreModule,
    SharedModule,
    ShellModule,
    HomeModule,
    InspirationModule,
    IconModule,
    NgxPiwikProModule.forRoot(
      Config.piwikContainer,
      'https://valdoise.piwik.pro'
    ),
    NgxPiwikProRouterModule,
    //TODO HERE, JUST USE ENV VARIABLE.
    // ! SECURITY CONCERNS !!!!!!!
    NgxGoogleAnalyticsModule.forRoot('UA-32584050-30'),
    AppRoutingModule, // must be imported as the last module as it contains the fallback route
  ],
  declarations: [AppComponent],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'fr-FR' }, CookieService],
  bootstrap: [AppComponent],
})
export class AppModule {}
